import React from 'react'
import { Button } from '@material-tailwind/react'
import Impdates from '../Utilities/Impdates'
import Notices from '../Utilities/Notices'
import Downloads from '../Utilities/Downloads'
import { Link } from 'react-router-dom';
import { Component } from '../Utilities/Carousel';
import du from "../images/Logos/du.jpg";
import rj from "../images/Logos/rajguru.png";
import dut from "../images/Logos/duytan.png";
import PrevKeynote from './PrevKeynotes'
import KeynoteSpeakers from './KeynoteSpeakers'


const Home = () => {
  const keynoteSpeakersData = {
    "2025": [
      { name:"Dr Bharati Rathore", desc: "University of South Wales UK", image: "/images/speakers/bharati.jpg" },
      { name:"Prof. Narayan C. Debnath", desc: "Eastern International University, Vietnam", image: "/images/speakers/debnath.jpg" },
      { name:"Prof. Anand Nayyar", desc: "Duy Tan University, Vietnam", image: "/images/speakers/nayyar.jpg" }
      
      
    ]
  }
  return (
    <div className='p-4'>
      <Component/>
      <h1 className='text-3xl text-center font-bold mt-4'>About Conference</h1>
      <hr className="mt-2 border-black border-2 w-96 m-auto"/>
      <p className='text-justify font-semibold mt-4'>ICCTRDA-2026 is organised with the objective of bringing together innovative scientists, professors, research scholars, students and industrial experts in the field of Computational Technologies, and Data Analytics to a common platform. The primary goal of the conference is to promote the exchange of innovative scientific information between researchers, developers, engineers, students, and practitioners. Overall the conference will provide the researchers and attendees with prospects for national and international collaboration and networking among universities and institutions for promoting research. ICCTRDA 2026 will be jointly organized by Duy Tan University, Vietnam on 26th - 28th November 2026.<br/><br/>
      All the accepted papers of ICCTRDA-2026 will be published as a proceedings of ICCTRDA-2026 in Springer LNNS series indexed by Scopus, Ei, WoS, and other reputed databases. Some papers will be invited to be submitted in Scopus and SCIE indexed Journals..
      </p>
      <Button color='blue' className='mt-4 p-3 '><Link to={'https://cmt3.research.microsoft.com/ICCTRDA2026'}>Paper Submission Link</Link></Button>
      <h1 className='text-3xl text-center font-bold mt-8'>Keynote Speakers of ICCRTDA:</h1>
      {/* <KeynoteSpeakers /> */}
      {/* <hr className="mt-2 border-black border-2 w-96 m-auto mb-4"/> */}


      <PrevKeynote speakersData={keynoteSpeakersData} />
      <h1 className='text-3xl text-center font-bold mt-8'>ICCTRDA Academic Partners</h1>
      <hr className="mt-2 border-black border-2 w-96 m-auto mb-4"/>

      <div className='w-[80%] mx-auto flex flex-wrap justify-evenly mb-16'>
        {/* <img src={du} className='w-40 h-auto m-4'/> */}
        {/* <img src={rj} className='w-40 h-auto m-4'/> */}
        <img src={dut} className='w-40 h-auto m-4'/>

      </div>
      <hr className="mt-2 border-black border-2 w-96 m-auto"/>
      <div></div>
      <br/><br/>
      <div className='flex flex-col md:flex-row justify-around my-8'>
      <Impdates />
      <Downloads/>
      <Notices/>
      </div>
      
    </div>
  )
}

export default Home